module.exports = __webpack_public_path__ + "img/text_guide.c6b2d58d.png";